import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import SectionGroupContainer from './components/section-group-container'
import { SHAPE_FACTSHEET_BLUEPRINT } from './shapes'
import './styles.scss'

class Factsheet extends PureComponent {
  render () {
    return (
      <div className="factsheet-container">
        <SectionGroupContainer
          blueprint={this.props.blueprint}
          factsheetBlueprint={this.props.blueprint}
        />
      </div>
    )
  }
}

Factsheet.propTypes = {
  blueprint: PropTypes.shape(SHAPE_FACTSHEET_BLUEPRINT).isRequired
}
export default Factsheet
